import BoardContentInformationApi from '@app/api/public/BoardContentInformationApi';
import { useMutation, useQueryClient } from 'react-query';
import { boardInformationQueryKeys } from './boardInformationQueries';

type Variables = { id: number };

const useSetInformationAsDraft = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return BoardContentInformationApi.setInformationAsDraft(varables.id);
        },
        {
            onSettled: (data, error, varables) => {
                client.invalidateQueries(boardInformationQueryKeys.lists());
                client.invalidateQueries(boardInformationQueryKeys.detail(varables.id));
            },
        }
    );
};

export default useSetInformationAsDraft;
